module.exports = __webpack_public_path__ + "./images/c79b7a8095bcabd2824e9fc6eb1d21f8.webp";